import { formatFileSize } from "@interface48/formatting";
import { Table, TableBodyRowButton } from "@interface48/tables";
import React, { useState } from "react";
import { VideoDto } from "../../../api";

interface VideosTableProps {
  results?: VideoDto[];
  width: number;
  height?: number;
  isLoading: boolean;
}

interface VideosTableState {
  sortDirection: "asc" | "desc";
  sortPropertyName: string;
}

export const VideosTableComponent = (props: VideosTableProps) => {
  const { results = [], width, height, isLoading } = props;
  const [tableState, setTableState] = useState<VideosTableState>({ sortDirection: "asc", sortPropertyName: "name" });

  const viewDetailsButtonRenderer = (id: string, row: VideoDto) => (
    <TableBodyRowButton icon={["fas", "info"]} title="View Details" linkUrl={`/administration/videos/${row.id}`} />
  );

  const fileSizeRenderer = (fileSize: number, row: VideoDto) => formatFileSize(fileSize);

  const handleSortChange = (sortPropertyName: string, sortDirection: "asc" | "desc") => {
    setTableState({ sortDirection, sortPropertyName });
  };

  return (
    <Table
      columnSchemas={[
        {
          id: "id",
          width: 40,
          cellRenderer: viewDetailsButtonRenderer,
        },
        {
          id: "name",
          label: "Name",
        },
        { id: "mediaCategoryName", label: "Category", hidden: width < 1200 },
        { id: "fileName", label: "File Name", hidden: width < 1360 },
        { id: "fileExtension", label: "File Extension", hidden: width < 1560 },
        { id: "fileSizeBytes", label: "File Size", cellRenderer: fileSizeRenderer, hidden: width < 1800 },
        {
          id: "lastModifiedAt",
          label: "Last Modified",
          width: 140,
          format: { type: "date-time", options: { reference: "relative" } },
        },
      ]}
      data={results}
      dataSourceType="local"
      sorting={{
        sortDirection: tableState.sortDirection,
        sortPropertyName: tableState.sortPropertyName,
        onSortChange: handleSortChange,
      }}
      height={height}
      isLoading={isLoading}
    />
  );
};

export const VideosTable = VideosTableComponent;
